import { TooltipContent } from '@anm/components/Tooltip';
import { flexRow, landscapeMedia, media } from '@anm/styles/helpers';
import styled, { css } from 'styled-components';

export const SetupLiveButtonWrapper = styled.div`
  ${TooltipContent} {
    min-width: 310px;
  }
`;

export const SetupWebinarButtonWrapper = styled.div`
  ${TooltipContent} {
    min-width: 210px;
  }
`;

export const NewRecordingButtonWrapper = styled.div`
  width: 180px;

  button {
    padding: 0;
    width: 100%;
  }

  ${TooltipContent} {
    min-width: 285px;
    left: 92px;
  }
`;

export const OpenStudioButtonWrapper = styled.div`
  width: 180px;
  ${TooltipContent} {
    min-width: 345px;
  }
`;

const commonMobileWrapper = css`
  margin-top: 15px;
  
  > div {
    flex: 1;
  }

  button {
    margin: 0;
    width: 100%;
    min-width: calc(50% - 10px);
  }
`;

const mobilePortraitWrapper = media.phone`
  ${commonMobileWrapper};
`;

const mobileLandscapeWrapper = landscapeMedia()`
  ${commonMobileWrapper};
`;

export const Wrapper = styled.div`
  ${flexRow};
  gap: 10px;
  flex-wrap: wrap;

  ${TooltipContent} {
    top: 62px;
    left: 50%;
    right: unset;
    color: #fff;
    padding: 12px 20px;
    transform: translateX(-50%);
  }

  ${mobilePortraitWrapper};
  ${mobileLandscapeWrapper};
`;

const commonMobileAddDestination = css`
  margin-top: 24px;
  * {
    width: 100%;
  }
  button {
    max-width: unset;
  }
`;

const mobilePortraitAddDestination = media.phone`
  ${commonMobileAddDestination};
`;

const mobileLandscapeAddDestination = landscapeMedia()`
  ${commonMobileAddDestination};
`;

export const AddDestinationWrapper = styled.div`
  ${mobilePortraitAddDestination};
  ${mobileLandscapeAddDestination};
`;
